import { Group } from '@components/layout';
import { useMemberLookup } from '@navigation/MemberLookupContext';
import { DateToNowDisplay } from './DateToNowDisplay';
import { TextProps, Typography } from './Typography';

type DateAndUserDisplayProps = TextProps & {
  date: string;
  user: string;
};

export const DateAndUserDisplay = ({ date, user, ...textProps }: DateAndUserDisplayProps) => {
  const memberName = useMemberLookup(user, 'Unknown');

  return (
    <Group alignItems="center" gap={1} flexWrap="wrap">
      <DateToNowDisplay date={date} sx={{ pr: 0 }} {...textProps} />
      <Typography variant="body2" {...textProps}>
        by {memberName}
      </Typography>
    </Group>
  );
};
